import { useParams } from 'react-router-dom';

import AfterCopyrightDecisionForm from "./AfterCopyrightDecisionForm"

function ReviewDecision() {
  const { offerID, committee, status } = useParams();
  return (
    <AfterCopyrightDecisionForm
      offerID={offerID}
      committee={committee}
      status={status}
    />
  )
}
export default ReviewDecision